<template>
  <context-menu :id="`${this.contextId}-confirmation-context-menu`" :ref="`${this.contextId}-confirmation-ctxMenu`" style="width: 400px;">
    <div class="m-2 row text-center">
      <div class="col-12 mb-3">
        <div v-html="introMessage"></div>
      </div>
      <div class="col-md-6">
        <button class="btn btn-danger btn-raised text-white" @click="$emit('deni')">
          <div v-html="(deniButtonContent) ? deniButtonContent : dictionary.cancel"></div>
        </button>
      </div>
      <div class="col-md-6">
        <button class="btn btn-success btn-raised text-white" @click="$emit('confirm')">
          <div v-html="(confirmButtonContent) ? confirmButtonContent : dictionary.confirm"></div>
        </button>
      </div>
    </div>
  </context-menu>
</template>

<script>

import contextMenu from 'vue-context-menu';
import { mapGetters } from 'vuex';

export default {
  name: 'ConfirmationContext',
  components: {
    contextMenu,
  },
  props: {
    introMessage: {
      type: String,
      required: true,
    },
    id: {
      required: false,
      type: String,
      default: 'unset',
    },
    confirmButtonContent: {
      required: false,
      type: String,
      default: undefined,
    },
    deniButtonContent: {
      required: false,
      type: String,
      default: undefined,
    },
  },
  data()
  {
    return {
      contextId: '',
    };
  },
  created()
  {
    this.contextId = (this.id === 'unset') ? this.contextId = this.getNewId() : this.id;
  },
  computed: {
    ...mapGetters(['dictionary']),
  },
  methods: {
    getNewId()
    {
      return this.$chance.string(this.$newIDParams);
    },
    openContext()
    {
      this.$refs[`${this.contextId}-confirmation-ctxMenu`].open();
    },
  },
};

</script>

<style scoped>

</style>
